import styled from "styled-components";

export const StyledAvatarSection = styled.div<{ $isComparison: boolean }>`
  display: flex;
  flex-direction: ${({ $isComparison }) => ($isComparison ? "row" : "column")};
  gap: ${({ $isComparison }) => ($isComparison ? "15px" : "8px")};
`;
